import { Swiper, SwiperSlide, type SwiperProps } from "swiper/react";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import ProductPlanCard from "./ProductPlanCard";
import type { ProductCard } from "./ProductsTypes";
import { getProductKey } from "./productsCardUtils";

export type ProductsSwiperProps = {
  products: ProductCard[];
  navigateOut: () => void;
  gtmHandleClick: (planName: string, id: number) => void;
  modules: SwiperProps["modules"];
  pagination: SwiperProps["pagination"];
  breakpoints?: SwiperProps["breakpoints"];
  slidesPerView?: SwiperProps["slidesPerView"];
  spaceBetween?: SwiperProps["spaceBetween"];
  freeMode?: SwiperProps["freeMode"];
  keyboard?: SwiperProps["keyboard"];
  grabCursor?: SwiperProps["grabCursor"];
  withMargin?: boolean;
};

export function ProductsSwiper({
  products,
  navigateOut,
  gtmHandleClick,
  modules,
  pagination,
  breakpoints,
  slidesPerView,
  spaceBetween,
  freeMode,
  keyboard = true,
  grabCursor = true,
  withMargin = false,
}: Readonly<ProductsSwiperProps>) {
  return (
    <Swiper
      freeMode={freeMode}
      grabCursor={grabCursor}
      keyboard={keyboard}
      breakpoints={breakpoints}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      pagination={pagination}
      modules={modules}
    >
      {products.map((product) => (
        <SwiperSlide key={getProductKey(product)}>
          <ProductPlanCard
            product={product}
            gtmHandleClick={gtmHandleClick}
            navigateOut={navigateOut}
            withMargin={withMargin}
            offerStampMode="oldPrice"
            priceLabelMode="oldPriceOnly"
            showOldPriceCurrency
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default ProductsSwiper;